import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { initGA, logPageView } from "./analytics";
import './App.css';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';
import Login from './pages/admin/Login';
import Home from "./pages/Home";
import Project from "./pages/Project";
import Plab24 from "./pages/Plab24";
import Admin from "./pages/admin/Admin";
import AdminPTLPreview from "./pages/admin/AdminPTLPreview";
import Preview from "./pages/project/ptl/preview/Preview";
import AdminPTLTeam from "./pages/admin/AdminPTLTeam";
import Stadium from "./pages/admin/Stadium";
import Stadium24 from "./pages/project/stadium24/Stadium24";
import Stadium24Message from "./pages/project/stadium24/Stadium24Message";
import AdminStadium24 from "./pages/admin/Stadium24";
import { HelmetProvider } from 'react-helmet-async';
import PDSHome from "./pages/pds/Home";
import Color from "./pages/pds/Color";
import Button from "./pages/pds/Button";
import Input from "./pages/pds/Input";
import Typography from "./pages/pds/Typography";
import Select from "./pages/pds/Select";
import Radio from "./pages/pds/Radio";
import Checkbox from "./pages/pds/Checkbox";
import Chip from "./pages/pds/Chip";
import MatchAssistant from "./pages/project/match_assistant/index";
import LevelGuide from "./pages/project/level1.5/LevelGuide";
import Plabthon from "./pages/project/hackathons/Hackathon";
import Products from './pages/project/hackathons/IdeaDetail';
import ScrollToTop from './components/common/ScrollToTop';
import FaqFuture from './pages/project/faq-future/FaqFuture';
import ProductRanking from './pages/project/hackathons/pages/ProductRanking';
import ResearcherRanking from './pages/project/hackathons/pages/ResearcherRanking';
import MyPage from './pages/project/hackathons/pages/MyPage';
import Lineup from './pages/admin/Lineup';
import LineupPage from './pages/lineup/index';
import PlabAI from './pages/plabai/index';
import HighlightPage from './pages/plabai/highlight/index';
const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <HelmetProvider>
      <AdminAuthProvider>
        <Router>
          <ScrollToTop />
          <TrackPageView />
          <Routes>
            {/* 일반 라우트 */}
            <Route path="/" element={<Home />} />
            <Route path="/project" element={<Project />} />
            <Route path="/project/plab24" element={<Plab24 />} />
            <Route path="/project/ptl/preview/:id" element={<Preview />} />
            <Route path="/stadium24/:id" element={<Stadium24 />} />
            <Route path="/stadium24/message" element={<Stadium24Message />} />
            <Route path="/pds" element={<PDSHome />} />
            <Route path="/pds/color" element={<Color />} />
            <Route path="/pds/button" element={<Button />} />
            <Route path="/pds/input" element={<Input />} />
            <Route path="/pds/typography" element={<Typography />} />
            <Route path="/pds/select" element={<Select />} />
            <Route path="/pds/radio" element={<Radio />} />
            <Route path="/pds/checkbox" element={<Checkbox />} />
            <Route path="/pds/chip" element={<Chip />} />
            <Route path="/project/match-assistant" element={<MatchAssistant />} />
            <Route path="/project/level-guide" element={<LevelGuide />} />
            <Route path="/project/plabthon" element={<Plabthon />} />
            <Route path="/project/plabthon/product-ranking" element={<ProductRanking />} />
            <Route path="/project/plabthon/researcher-ranking" element={<ResearcherRanking />} />
            <Route path="/project/plabthon/my" element={<MyPage />} />
            <Route path="/project/plabthon/:ideaId" element={<Products />} />
            <Route path="/project/faq-future" element={<FaqFuture />} />
            <Route path="/lineup/:matchId" element={<LineupPage />} />
            <Route path="/plabai" element={<PlabAI />} />
            <Route path="/plabai/highlight" element={<HighlightPage />} />
            {/* 관리자 로그인 */}
            <Route path="/admin/login" element={<Login />} />
            
            {/* 보호된 관리자 라우트 */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } />
            <Route path="/admin/ptl-preview" element={
              <ProtectedRoute>
                <AdminPTLPreview />
              </ProtectedRoute>
            } />
            <Route path="/admin/team" element={
              <ProtectedRoute>
                <AdminPTLTeam />
              </ProtectedRoute>
            } />
            <Route path="/admin/stadium" element={
              <ProtectedRoute>
                <Stadium />
              </ProtectedRoute>
            } />
            <Route path="/admin/stadium24" element={
              <ProtectedRoute>
                <AdminStadium24 />
              </ProtectedRoute>
            } />
            <Route path="/admin/lineup" element={
              <ProtectedRoute>
                <Lineup />
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </AdminAuthProvider>
    </HelmetProvider>
  );
}

export default App;
